

import Vue from 'vue';
import CoreAppBar from "@/views/AppBar.vue";

export default Vue.extend({
  name: 'App',

  components: {
      CoreAppBar: CoreAppBar,
  },

  data: () => ({
    items: [
      ['mdi-email', 'Table'],
      ['mdi-account-supervisor-circle', 'Map']
    ],
  }),
  computed: {
    isLoggedIn() {
      return this.$store.getters['auth/isLoggedIn']
    },
  }
});
